import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Typography} from '@material-ui/core';
import ReactsCard from "../components/ui/ReactsCard";
import {WithOrganization} from "../components/organizations/organization-context";
import {ReportFormat, UsageStatsRequest} from "../models/report.model";
import {downloadOrganizationUsageStats} from "../api/reporting-functions";
import {downloadFile} from "../utils/function-util";
import Grid from "@material-ui/core/Grid";
import {DatePicker} from "@material-ui/pickers";
import {isBefore, startOfMonth, subMonths} from "date-fns";
import config from '../config';
import {useCapability} from "../auth/CapabilityContext";
import {Roles} from "../auth/roles";
import withReportDownloadComponentStyle from "../components/ui/styles/StyledReportDownloadComponent";


const lastMonth = startOfMonth(subMonths(new Date(), 1));

const UsageStats: React.FC<WithOrganization> = ({currentOrganization, classes}: any) => {
    const {t, i18n} = useTranslation();
    const { hasRole } = useCapability();
    const isIITAdmin = hasRole(Roles.ADMIN);
    const firstAvailableMonth = isIITAdmin ? new Date(2021,0,1) : subMonths(config.usageStats.rolloutDate, 1)
    // Stats not offered until month closes for customers
    const lastAvailableMonth = isIITAdmin ? new Date() : new Date(lastMonth);
    const [startDate, handleStartDateChange] = useState<Date | null>(new Date(lastMonth));
    const [endDate, handleEndDateChange] = useState<Date | null>(new Date(lastMonth));

    const downloadStats = async () => {
        if(!startDate || !endDate)
            return;

        const request: UsageStatsRequest = {
            organizationId: currentOrganization.id,
            format: ReportFormat.SPREADSHEET,
            language: i18n.language,
            startDate: startDate,
            endDate: endDate
        }
        const {blob, filename} = await downloadOrganizationUsageStats(request);
        downloadFile(blob, filename);
    };

    const handleStartDate = (newStartDate: Date | null) => {
        handleStartDateChange(newStartDate);
        if(endDate && newStartDate && isBefore(endDate, newStartDate)){
            handleEndDateChange(newStartDate);
        }
    }

    return (
        <ReactsCard title={t('UsageStats.Title')} className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        {t('UsageStats.Paragraph')}
                    </Typography>
                </Grid>
                <Grid className={classes.dates} container item xs={12} md={9} lg={6} alignItems="center">
                    <Grid item xs={4}>
                        <DatePicker
                            required
                            views={["year", "month"]}
                            openTo="year"
                            format="MM/yyyy"
                            label={t("_Common.Labels.StartDate")}
                            minDate={firstAvailableMonth}
                            maxDate={lastAvailableMonth}
                            value={startDate}
                            onChange={handleStartDate}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <DatePicker
                        views={["year", "month"]}
                        openTo="year"
                        format="MM/yyyy"
                        label={t("_Common.Labels.EndDate")}
                        minDate={startDate}
                        maxDate={lastAvailableMonth}
                        value={endDate}
                        onChange={handleEndDateChange}
                    />
                    </Grid>
                    <Grid item xs={4}>

                    <Button variant="contained" color="primary" size="medium"
                            onClick={downloadStats}>
                        { t('UsageStats.DownloadReport') }
                    </Button>
                    </Grid>
                </Grid>
            </Grid>
        </ReactsCard>
    )
};

export const StyledUsageStats = withReportDownloadComponentStyle(UsageStats);
